"use client";
import ArticleBody from "@/components/ArticleBody";
import { articlePresentation } from "@/lib/articles/presentation";
import ArticleImageCaption from "@/components/ArticleImageCaption";

import React from 'react';

export default function CorporateArticleClient({ initialArticle, settings }) {
  if (!initialArticle) return null;
  const holding = settings?.general?.corporate?.presentation === "holding";
  const presentation = articlePresentation(initialArticle);

  const publishedDate = new Date(initialArticle.publishedAt || initialArticle.createdAt).toLocaleDateString('en-US', { 
    month: 'long', 
    day: 'numeric', 
    year: 'numeric' 
  });

  return (
    <div className="w-full font-sans text-black pt-12 pb-24" style={{ backgroundColor: 'transparent' }}>
      <div className={holding ? "holding-article-reading" : "max-w-[1400px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-[120px_1fr] xl:grid-cols-[160px_1fr] gap-12 lg:gap-24"}>
        
        {!holding && <>
        {/* Left Column: Vertical Identity */}
        <div className="hidden lg:flex flex-col items-start pr-4">
          <div className="sticky top-24 transform -rotate-180" style={{ writingMode: 'vertical-rl' }}>
            <span className="text-[100px] leading-none font-black text-black uppercase tracking-tighter pointer-events-none select-none">
              SURGEZIRC MEDIA
            </span>
          </div>
        </div>
        
        {/* Mobile Vertical Identity */}
        <div className="lg:hidden flex items-center mb-8 border-b-4 border-black pb-4">
            <span className="text-4xl font-black text-black uppercase tracking-tighter">
              SURGEZIRC MEDIA
            </span>
        </div>

        </>}
        {/* Center Column: Wide Article Body (approx 900-1100px) */}
        <div className="w-full max-w-[1000px]">
          
          <div className="mb-4">
            <span className="text-sm font-bold uppercase tracking-widest text-black">
              {initialArticle.category || 'COMPANY NEWS'}
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-black mb-6 leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
            {initialArticle.title}
          </h1>
          {presentation.subtitle && <p data-article-subtitle className="text-xl md:text-2xl leading-relaxed mb-6">{presentation.subtitle}</p>}

          <div className="mb-16">
            <span className="text-sm font-medium text-gray-600 uppercase tracking-wider">
              {publishedDate}
            </span>
          </div>

          {presentation.image && <figure className="mb-8">
            <img src={presentation.image} alt={presentation.imageAlt} className="w-full h-auto object-cover" />
            <ArticleImageCaption article={initialArticle} className="mt-2 text-sm text-gray-600" />
          </figure>}

          <ArticleBody
            className="prose prose-gray max-w-none [&_h2]:font-bold [&_h2]:text-black [&_h3]:font-bold [&_h3]:text-black [&_a]:text-black [&_a]:underline hover:[&_a]:no-underline text-[16px] md:text-[17px] lg:text-[18px] [&_p]:leading-[1.7] [&_li]:leading-[1.7]"
            style={{ fontFamily: "'Inter', sans-serif" }}
            html={initialArticle.content}
          />

          <div className="mt-16 pt-8">
            <p className="text-xl font-medium text-black" style={{ fontFamily: "'Inter', sans-serif" }}>
              By {initialArticle.author}
            </p>
          </div>
          
        </div>
      </div>
    </div>
  );
}
